import { atsApiQuery } from '..';
import { FILTER_OPTIONS_STALE_SECONDS } from '@/constants/app-constants';

export const departmentsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAtsDepartments: builder.query({
        providesTags: ['GetAtsDepartments'],
        // Admin-managed config. The 60s default evicted it between page visits,
        // which forced a refetch no freshness window could prevent.
        keepUnusedDataFor: FILTER_OPTIONS_STALE_SECONDS,
        transformResponse: (response) => response?.data?.departments,
        query: () => {
          return {
            method: 'get',
            url: `/ats_departments`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useGetAtsDepartmentsQuery } = departmentsApi;
